/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Termination_FinalInputs */

const en_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel now`)
};

const de_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jetzt kündigen`)
};

const fr_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résilier maintenant`)
};

const es_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar ahora`)
};

const it_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risolvi ora`)
};

const nl_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu opzeggen`)
};

const pl_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypowiedz teraz`)
};

const fi_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irtisano nyt`)
};

const da_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsig nu`)
};

const sv_consumer_declaration_termination_final = /** @type {(inputs: Consumer_Declaration_Termination_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säg upp nu`)
};

/**
* | output |
* | --- |
* | "Cancel now" |
*
* @param {Consumer_Declaration_Termination_FinalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_termination_final = /** @type {((inputs?: Consumer_Declaration_Termination_FinalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Termination_FinalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_termination_final(inputs)
	if (locale === "fr") return fr_consumer_declaration_termination_final(inputs)
	if (locale === "es") return es_consumer_declaration_termination_final(inputs)
	if (locale === "it") return it_consumer_declaration_termination_final(inputs)
	if (locale === "nl") return nl_consumer_declaration_termination_final(inputs)
	if (locale === "pl") return pl_consumer_declaration_termination_final(inputs)
	if (locale === "fi") return fi_consumer_declaration_termination_final(inputs)
	if (locale === "da") return da_consumer_declaration_termination_final(inputs)
	if (locale === "sv") return sv_consumer_declaration_termination_final(inputs)
	return en_consumer_declaration_termination_final(inputs)
});